import { BasePayloadMapper } from '@ps/utils';

import { CreateTagRequest } from '@ps/feature-tags';
import { TagCreateDto } from '../dtos/tag-create.dto';

export class TagPayloadMapper extends BasePayloadMapper<
  CreateTagRequest,
  TagCreateDto
> {
  public toPayload(from: CreateTagRequest): TagCreateDto {
    return {
      label: from.label,
      emoji: from.emoji,
    };
  }
}
